import NotificationCard from "./NotificationCard";

export default function PlaylistNotificationCard(props) {
    return (
        <NotificationCard
            {...props}
            type="playlist"
            destination={"/playlist?key=" + props.notification.key}
            mediaUrl={
                "https://vz-db0e7359-d70.b-cdn.net/" +
                props.notification.file +
                "/thumbnail.jpg"
            }
            mediaAlt="Playlist thumbnail"
        />
    );
}
